// src/Components/LoadingScreen.jsx
import React, { useState, useEffect } from 'react';

const LoadingScreen = ({ 
    message = "טוען מוצרים...", 
    delay = 1000,
    loading = false
}) => {
    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
       
        if (!loading) {
            setShowSpinner(false);
            return;
        }
    
        // Start timer when loading becomes true
        const timer = setTimeout(() => {
            setShowSpinner(true);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [loading, delay]);

    // Don't show anything if not loading or spinner not ready
    if (!loading || !showSpinner) {
        return null;
    }

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            <div className="text-center">
                <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h5 className="text-primary">{message}</h5>
            </div>
        </div>
    );
};

export default LoadingScreen;